function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "m400.335938 192c0 66.273438-53.726563 120-120 120-66.277344 0-120-53.726562-120-120s53.722656-120 120-120c66.273437 0 120 53.726562 120 120zm0 0",
  fill: "#fdd020"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "m280.335938 48c-4.421876 0-8-3.582031-8-8v-32c0-4.417969 3.578124-8 8-8 4.417968 0 8 3.582031 8 8v32c0 4.417969-3.582032 8-8 8zm0 0",
  fill: "#fdd020"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "m464.335938 200h-32c-4.421876 0-8-3.582031-8-8s3.578124-8 8-8h32c4.417968 0 8 3.582031 8 8s-3.582032 8-8 8zm0 0",
  fill: "#fdd020"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "m376.335938 296c-5.851563 0-11.691407.585938-17.425782 1.742188-4.324218-21.582032-18.304687-39.992188-37.933594-49.957032-19.625-9.964844-42.738281-10.382812-62.714843-1.136718-18.078125-49.796876-73.101563-75.507813-122.898438-57.429688-49.796875 18.082031-75.507812 73.105469-57.429687 122.902344-43.621094 1.378906-78.078125 37.480468-77.425782 81.121094.65625 43.636718 36.183594 78.6875 79.828126 78.757812h296c48.597656 0 88-39.398438 88-88s-39.402344-88-88-88zm0 0",
  fill: "#a3d4f7"
});

var _ref6 = /*#__PURE__*/React.createElement("g", {
  fill: "#fdd020"
}, /*#__PURE__*/React.createElement("path", {
  d: "m168.335938 80-32-32"
}), /*#__PURE__*/React.createElement("path", {
  d: "m168.335938 88c-2.125 0-4.15625-.84375-5.65625-2.34375l-32-32c-2.082032-2.007812-2.914063-4.984375-2.183594-7.78125.734375-2.796875 2.917968-4.980469 5.714844-5.710938 2.796874-.734374 5.769531.101563 7.78125 2.179688l32 32c2.285156 2.289062 2.96875 5.730469 1.730468 8.71875-1.238281 2.988281-4.152344 4.9375-7.386718 4.9375zm0 0"
}), /*#__PURE__*/React.createElement("path", {
  d: "m392.335938 80 32-32"
}), /*#__PURE__*/React.createElement("path", {
  d: "m392.335938 88c-3.238282 0-6.152344-1.949219-7.390626-4.9375-1.238281-2.988281-.554687-6.429688 1.734376-8.71875l32-32c2.007812-2.078125 4.980468-2.914062 7.777343-2.179688 2.796875.730469 4.984375 2.914063 5.714844 5.710938s-.101563 5.773438-2.179687 7.78125l-32 32c-1.5 1.5-3.535157 2.34375-5.65625 2.34375zm0 0"
}));

var SvgSmallCloud = function SvgSmallCloud(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "472pt",
    viewBox: "1 0 471 472",
    width: "472pt",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSmallCloud, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/small-cloud.e9ee5d2d.svg";
export { ForwardRef as ReactComponent };